<template>
    <div class="answer" :class="getClass" @click="onClick">
        <span>{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: "Answer",
        props: ['answer','clickable'],
        data() {
            return {
                revealed: false
            }
        },
        computed: {
            text() {
                if (this.isCorrect) return this.answer.substring(1, this.answer.length);
                return this.answer;
            },
            isCorrect() {
                return this.answer.substring(0, 1) === "*"
            },
            getClass() {
                if (!this.revealed) return '';
                return this.isCorrect ? 'green' : 'red';
            }
        },
        methods: {
            onClick() {
                if (!this.clickable) return;
                this.revealed = true;
                this.$emit('click',this.isCorrect);
            }
        }
    }
</script>

<style scoped>
    .answer {
        color: #002438;
        width: 426px;
        height: 80px;
        display: flex;
        margin-bottom: 30px;
        box-sizing: border-box;
        background-color: white;
        justify-content: center;
        align-items: center;
        font-size: 33px;
        cursor: pointer;
        transition: background-color 500ms ease-in-out;
    }

    .answer.green {
        background-color: #83BB26;
        color: white;
    }
    .answer.red {
        background-color: #B71E3F;
        color: white;
    }

</style>



// WEBPACK FOOTER //
// src/components/Answer.vue